export default __webpack_public_path__ + "static/media/profile-icon.cf0207f5.svg";